/**
 * @author che
 */
import { SIZES, getVersion } from "../dom/screen";

class Scrollband extends HTMLElement {
	constructor() {
		super();
		this.index = 0;
		this.scroller = null;
		this.scrollElements = [];
		this.visibleElementsOverwrite = {};
	}

	/**
	 * Number of elements visible in current screen size
	 */
	get visibleElements() {
		const version = getVersion();
		let number = 1;
		for (let i = 0; i < SIZES.length; i++) {
			if (SIZES[i] == version) {
				return this.visibleElementsOverwrite[version] || number;
			}
			number = this.visibleElementsOverwrite[SIZES[i]] || number;
		}
		return number;
	}

	connectedCallback() {
		this.scroller = this.querySelector(this.getAttribute("scroller"));
		if (!(this.scroller instanceof HTMLElement)) {
			throw new Error(
				"attribute selector must be set and a valid query selector",
			);
		}
		this.scrollElements = this.scroller.children;
		this.getAttribute("visible-elements")
			.split(",")
			.forEach(setting => {
				const [version, number] = setting.split(":");
				this.visibleElementsOverwrite[version] = parseInt(number, 10);
			});
		this.addEventListener("ScrollTo", event => {
			event.stopPropagation();
			this.go(this.index + (event.detail === "left" ? -1 : +1));
		});
	}

	go(index) {
		if (
			index < 0 ||
			index + this.visibleElements > this.scrollElements.length
		) {
			return;
		}
		this.index = index;

		this.scrollElements[index].scrollIntoView({
			block: "nearest",
			inline: "start",
			behavior: "smooth",
		});
	}

	scrollNodeIntoView(node) {
		const index = Array.from(this.scrollElements).indexOf(node);
		this.go(index);
	}
}
customElements.define("esc-scrollband", Scrollband);
